import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { PDSService } from '../../../services/pds.service';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-pds',
  standalone: true,
  imports: [
    CommonModule,
    FooterComponent,
    StaticSearchComponent,
    CommonHeaderComponent,
    RouterLink,
  ],
  templateUrl: './pds.component.html',
  styleUrl: './pds.component.scss',
  providers: [DatePipe],
})
export class PdsComponent implements OnInit {
  allPDSList: any[] = [];
  sameDatesPDSGroup: any[] = [];
  differentDatesPDSGroup: any[] = [];
  allTMDList: any[] = [];
  currentTMDList: any[] = [];
  previousTMDList: any[] = [];
  partnerCode = '';

  constructor(
    public pdsService: PDSService,
    private datePipe: DatePipe,
    private titleService: Title,
    private metaService: Meta,
  ) {
    this.titleService.setTitle(
      'Policy Documentation | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'View World2Cover Policy Documentation. Learn about policy terms, cover, exclusions, benefits, rights, and obligations.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Policy Documentation | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'View World2Cover Policy Documentation. Learn about policy terms, cover, exclusions, benefits, rights, and obligations.',
    });
  }

  ngOnInit() {
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
    this.pdsService.currentPartnercode.subscribe((code: string) => {
      if (this.partnerCode != 'Klook' && this.partnerCode != 'vacatio')
        this.partnerCode = code;
    });
    this.getAllPDSs();
    this.getAllTMDs();
  }

  getAllPDSs() {
    this.pdsService.getAllPDS().subscribe((response) => {
      if (response) {
        this.allPDSList = response?.pds.sort();
      }
      this.groupPdsByDates();
    });
  }

  getAllTMDs() {
    this.pdsService.getAllTMD().subscribe((response) => {
      if (response) {
        this.allTMDList = response?.tmd.sort();
      }
      this.currentTMDList = this.allTMDList.filter(
        item => item.isActive === true
      );
      this.previousTMDList = this.allTMDList.filter(
        item => item.isActive === false
      );
      this.previousTMDList.reverse();
    });
  }


  groupPdsByDates(): void {
    const dateMap = new Map();
    for (const pds of this.allPDSList) {
      const key = `${pds.validFrom}-${pds.validUntil}`;
      if (!dateMap.has(key)) {
        dateMap.set(key, []);
      }
      dateMap.get(key).push(pds);
    }

    dateMap.forEach((value: any[], key: string) => {
      if (value.length > 1) {
        const tempArray = [
          {
            validFrom: value[0].validFrom,
            validUntil: value[0].validUntil,
            pds: value,
          },
        ];
        this.sameDatesPDSGroup = this.sameDatesPDSGroup.concat(tempArray);
      } else {
        this.differentDatesPDSGroup = this.differentDatesPDSGroup.concat(value);
      }
    });
  }

  formatDate(dateStr: string): string {
    const [day, month, year] = dateStr.split('/');
    const dateObj = new Date(+year, +month - 1, +day);

    const formattedDate = this.datePipe.transform(dateObj, 'd MMMM yyyy');
    const dayWithOrdinal = this.appendOrdinal(+day);

    return `${dayWithOrdinal} ${formattedDate?.slice(
      formattedDate.indexOf(' ') + 1,
    )}`;
  }

  appendOrdinal(n: number): string {
    if (n > 3 && n < 21) return n + 'th';
    switch (n % 10) {
      case 1:
        return n + 'st';
      case 2:
        return n + 'nd';
      case 3:
        return n + 'rd';
      default:
        return n + 'th';
    }
  }

  viewPDSPDF(pds: any): void {
    window.open(pds.previewUrl, '_blank');
  }

  downloadPDS(pds: any) {
    this.pdsService.downloadPDSPDF(pds.url, pds.name);
  }

  viewTMDPDF(tmd: any): void {
    window.open(tmd.url, '_blank');
  }

  downloadTMD(tmd: any) {
    this.pdsService.downloadPDSPDF(tmd.downloadUrl, tmd.name);
  }
}
